import { Box } from '@mui/material';
import type { BackupStatus } from '@repo/api-gw-sdk';
import React from 'react';

import { BackupStatuses } from '@/data/inventory/data';

export const BackupStatusIcon = React.forwardRef(
  ({ backupStatus, ...props }: { backupStatus: BackupStatus }, ref) => {
    const data = BackupStatuses[backupStatus];
    if (!data) {
      return null;
    }

    return (
      <Box
        ref={ref}
        {...props}
        component={'span'}
        className='rounded-full inline-flex p-[2px]'
        sx={{
          background: data.backgroundColor,
        }}
      >
        <i
          className={`${data.icon} h-[20px] w-[20px]`}
          style={{ background: data.iconColor }}
        />
      </Box>
    );
  }
);
